export default [
  {
    path: '/main/remoteid',
    meta: {
      tag: 'remoteid',
      name: 'Remote ID',
      breadcrumb: 'Remote ID',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "remote-id" */ '@/views/main/settings/app-frotix-registers/remoteid/Add.vue')
  }
]
